import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import {
  ProductionAnalysisParams,
  ProductionAnalysisResponse,
  ExportCSVParams,
  SpeedAnalysisDetail,
} from "./models";

export const productionAnalysisApi = createApi({
  baseQuery,
  reducerPath: "productionAnalysisApi",
  tagTypes: ["productionAnalysis"],
  endpoints: (builder) => ({
    getProductionAnalysis: builder.query<
      ProductionAnalysisResponse,
      ProductionAnalysisParams
    >({
      query: (params) => ({
        url: "/api/v1/order_production_set/",
        method: "GET",
        params,
      }),
      providesTags: ["productionAnalysis"],
    }),
    exportCSV: builder.mutation<Blob, ExportCSVParams>({
      query: (params) => ({
        url: "/api/v1/order_production_set/csv_analysis_export/",
        method: "POST",
        params,
        responseHandler: (response) => response.blob(),
      }),
    }),
    getSpeedAnalysisDetail: builder.query<SpeedAnalysisDetail, number>({
      query: (id) => ({
        url: `/api/v1/order_production_set/${id}/speed_analysis_detail/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetProductionAnalysisQuery,
  useExportCSVMutation,
  useGetSpeedAnalysisDetailQuery,
} = productionAnalysisApi;
